import { Routes } from "@angular/router";
import { DirtyGuard } from "~app/common/guards/dirty.guard";
import { RaskRoller } from "~app/common/models/constants";
import { DestineringsomradenComponent } from "~app/features/transport/destineringsomraden/destineringsomraden.component";
import { TransportforetagRedigeraComponent } from "~app/features/transport/transportforetag/transportforetag-redigera/transportforetag-redigera.component";
import { TransportforetagComponent } from "~app/features/transport/transportforetag/transportforetag.component";
import { TransportplaneraComponent } from "~app/features/transport/transportplanera/transportplanera.component";

export const transportRoutes: Routes = [
    {
        path: "transportforetag",
        title: "Transportföretag",
        children: [
            {
                path: "",
                component: TransportforetagComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Titta],
                    editRoles: [
                        RaskRoller.role.Administrera,
                        RaskRoller.role.Produktadministrera
                    ]
                }
            },
            {
                path: ":id",
                title: "Detaljer",
                component: TransportforetagRedigeraComponent,
                canDeactivate: [DirtyGuard],
                data: {
                    requiredRoles: [RaskRoller.role.Titta],
                    editRoles: [
                        RaskRoller.role.Administrera,
                        RaskRoller.role.Produktadministrera
                    ],
                    volatileState: "transportforetag"
                }
            }
        ]
    },
    {
        path: "transportplanera",
        title: "Transportplanera",
        canDeactivate: [DirtyGuard],
        component: TransportplaneraComponent,
        data: {
            requiredRoles: [RaskRoller.role.Titta],
            editRoles: [RaskRoller.role.Produktionsleda]
        }
    },
    {
        path: "destineringsomraden",
        title: "Destineringsområden",
        component: DestineringsomradenComponent,
        canDeactivate: [DirtyGuard],
        data: {
            requiredRoles: [RaskRoller.role.Titta],
            editRoles: [RaskRoller.role.Produktionsleda]
        }
    }
];
